module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/solid/map-marker-check.svg?0911d4fd95db873993ffa8e682cad490";